import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function MatterPostureCard({ answer }: Props) {
  return (
    <article className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-emerald-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          Matter posture
        </span>
        {answer.stage && (
          <span className="rounded bg-emerald-100 px-1.5 py-0.5 text-[10px] uppercase tracking-wide text-emerald-800">
            stage: {answer.stage}
          </span>
        )}
        {answer.priority && (
          <span className="rounded bg-emerald-100 px-1.5 py-0.5 text-[10px] uppercase tracking-wide text-emerald-800">
            priority: {answer.priority}
          </span>
        )}
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
